import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
/** Symbol to signal "pull this field from context" */ export const BiContextProvidedValue = Symbol('BiContextProvidedValue');
/** BiData that supports pulling from context, use for logging from components */ export function BiData(data) {
    return _object_spread_props(_object_spread({}, data), {
        _biLoggerVersion: 2
    });
}
